var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1579 53.881C63.3388 52.5963 64.527 51.7014 65.8117 51.8823C69.1169 52.3476 71.5571 55.2054 71.4903 58.5421V64.8817C71.4903 66.1791 70.4385 67.2309 69.1411 67.2309C67.8437 67.2309 66.7919 66.1791 66.7919 64.8817V58.516C66.7919 58.4965 66.7921 58.4771 66.7926 58.4576C66.8164 57.4998 66.1167 56.67 65.1567 56.5348C63.8719 56.3539 62.977 55.1658 63.1579 53.881Z",
    fill: "#F4F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1316 62.5325C70.429 62.5273 71.485 63.5747 71.4903 64.8722C71.4979 66.7302 70.7201 68.5042 69.35 69.7587C68.3931 70.6349 66.9071 70.5694 66.0309 69.6125C65.1548 68.6556 65.2202 67.1696 66.1771 66.2935C66.5715 65.9323 66.7941 65.4231 66.7919 64.8913C66.7866 63.5939 67.8341 62.5378 69.1316 62.5325Z",
    fill: "#F4F6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6776 55.3464L53.983 58.0356C53.0647 58.9521 51.5773 58.9507 50.6607 58.0323C49.7442 57.114 49.7457 55.6266 50.664 54.7101L53.3735 52.006C55.2056 50.1979 57.9222 49.6198 60.332 50.5225C62.0945 51.1787 63.9257 51.6339 65.7907 51.8794C67.0771 52.0487 67.9826 53.2287 67.8133 54.5151C67.644 55.8014 66.4639 56.7069 65.1776 56.5376C62.9611 56.2459 60.7847 55.7048 58.6899 54.9247L58.6846 54.9227C57.9889 54.6617 57.2056 54.8282 56.6776 55.3464Z",
    fill: "#F4F6FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4542 26.855C33.4554 28.1525 32.4047 29.2052 31.1072 29.2064C30.5714 29.2069 30.0616 29.4322 29.702 29.8254C29.3459 30.2147 29.1692 30.7332 29.2124 31.2562C29.8738 37.4394 31.9836 43.3811 35.3717 48.6008L35.3829 48.6181C38.4618 53.4538 42.57 57.5541 47.416 60.6274L47.4344 60.639C52.6407 64.0086 58.5657 66.1144 64.7346 66.7873C65.264 66.8302 65.7868 66.6509 66.1771 66.2935C67.134 65.4173 68.6201 65.4827 69.4963 66.4396C70.3724 67.3965 70.3069 68.8826 69.35 69.7587C67.9801 71.013 66.1449 71.632 64.2952 71.4652L64.253 71.461C57.3497 70.7124 50.7182 68.359 44.8908 64.5894C39.4696 61.1496 34.8723 56.5616 31.4252 51.1503C27.6342 45.307 25.2747 38.6546 24.538 31.7315L24.5344 31.6948C24.3674 29.85 24.9851 28.021 26.235 26.6544C27.4848 25.288 29.2514 24.5098 31.1028 24.508C32.4002 24.5068 33.453 25.5576 33.4542 26.855Z",
    fill: "#F4F6FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4083 30.8279C39.2718 29.8937 38.4625 29.1969 37.5064 29.2063L37.4833 29.2065L31.105 29.2064C29.8075 29.2064 28.7558 28.1547 28.7558 26.8572C28.7558 25.5598 29.8075 24.508 31.105 24.508H37.473C40.7772 24.4819 43.5976 26.9017 44.0615 30.1775L44.0646 30.1991C44.3105 32.0595 44.7662 33.8863 45.4234 35.6446C46.3299 38.055 45.7482 40.771 43.9358 42.6001L43.9266 42.6095L42.5329 44.0004C45.2919 48.2648 49.0455 51.8115 53.483 54.3297C54.6114 54.9701 55.0071 56.4039 54.3667 57.5323C53.7264 58.6607 52.2925 59.0564 51.1641 58.416C45.4739 55.1869 40.7619 50.4845 37.5257 44.8044C37.0014 43.8842 37.1577 42.7269 37.9074 41.9787L40.6021 39.2894C41.1205 38.7632 41.2848 37.9862 41.0254 37.2975L41.0234 37.2922C40.243 35.205 39.7012 33.0365 39.4083 30.8279Z",
    fill: "#F4F6FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0173C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneConfirmationIcon);
export default __webpack_public_path__ + "static/media/PhoneConfirmationIcon.b6871f0e.svg";
export { ForwardRef as ReactComponent };